'use strict';

var DURATION_UNITS = require('./DURATION_UNITS');

module.exports = RegExp('(\\d+)?\\s*('+ DURATION_UNITS +')s?', 'i');


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/var/DURATION_REG.js
// module id = 430
// module chunks = 1